import { IGerenciarControleReparo } from "../../../Interfaces/AssistenciaTecnica/GerenciarControleReparo/GerenciarControleReparoInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export function obterDadosControleReparo(idCaso: number) {
    return Service(
        Axios.get(`/assistenciatecnica/acaoatendimento/getmanutencaoAtendimento?idCaso=${idCaso}`)
    );
}

export function atualizarDadosControleReparo(data: IGerenciarControleReparo) {
    return Service(
        Axios.put(`/assistenciatecnica/acaoatendimento/atualizarmanutencaoatendimento`, data)
    );
}
